export const pricingGettingStartedArticle = {
  title: 'Pricing Intelligence Suite: Getting Started',
  slug: 'pricing-intelligence-getting-started',
  content: `Pricing Intelligence Suite: Getting Started

Use the Pricing Hub to calculate prices, analyze margins, and draft strategy.

1) Open Pricing Hub
- Go to /pricing-hub.
- Tabs use URL hashes (#calculator, #margin, #strategy).

2) Price Calculator
- Model pricing and revenue targets.

3) Margin Analysis
- Review margin impacts across products or services.

4) AI Strategy
- Use the strategy tab for positioning and pricing guidance.
`,
};
